
export const config = {
    discordLink: "https://discord.gg/zW59zzGggS",
    openseaLink: "https://opensea.io/collection/the-rocking-uniquehorns",
    twitterLink: "https://twitter.com/Uniquehorns_nft",
    decentrallangLink: "https://play.decentraland.org/?position=26%2C-118",
};
